const state = {
  user: null
};
const getters = {
  userId(state) {
    if (state.user) {
      return state.user.uid;
    }
  },
  profile(state) {
    if (state.user) {
      let user = { name: state.user.displayName, photo: state.user.photoURL };
      return user;
    }
  }
};
const mutations = {
  setUser(state, dataUser) {
    state.user = dataUser;
  }
};

const actions = {
  // updatePhoto() {
  //   console.log(user.photoURL.includes("google"));
  //         user
  //           .updateProfile({
  //             photoURL: "https://img.icons8.com/color/48/000000/madagaskar.png"
  //           })
  //           .then(function() {
  //             // Update successful.
  //             console.log("yes");
  //           })
  //           .catch(function(error) {
  //             // An error happened.
  //           });
  // }
};

export default {
  state,
  getters,
  mutations,
  actions
};
